import {useMatchMedia} from '@pexip/hooks';

import {LANDSCAPE} from '../../constants/mediaQueries';

export const useLandscape = () => useMatchMedia(LANDSCAPE);
